"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFERRAL_OUTCOMES = void 0;
/**
 * Client-side lifecycle when resolving a referral code (e.g. Apollo `referrerInfo`).
 * Not the same as referral DB status (`pending` / `completed`).
 *
 * Also used in the legacy Strapi referral controller for `referralFetchOutcome` on Sentry extras so logs line up with the Nuxt plugin.
 */
exports.REFERRAL_OUTCOMES = {
    ok: 'ok',
    noClient: 'no_client',
    error: 'error',
};
//# sourceMappingURL=index.js.map